<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M544 320C544 443.7 443.7 544 320 544C196.3 544 96 443.7 96 320C96 196.3 196.3 96 320 96C443.7 96 544 196.3 544 320zM64 320C64 461.4 178.6 576 320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320zM304 176L304 320C304 325.4 306.7 330.3 311.1 333.3L407.1 397.3C414.5 402.2 424.4 400.2 429.3 392.9C434.2 385.6 432.2 375.6 424.9 370.7L336 311.4L336 176C336 167.2 328.8 160 320 160C311.2 160 304 167.2 304 176z"
      fill="currentColor"
    />
  </svg>
</template>